define(function(require){
    'use strict';

    var Marionette = require('marionette');
    var AppConfig = require("config/application");

    return Backbone.Model.extend({
        url: '/server/?action=getSiteSettings'
    });
});
